<div class="workspace-tab-panel w-100">
  <header class="workspace-section-head mb-4 text-start">
    <h1 class="mb-1">EngageNet</h1>
    <p class="mb-0">Community engagement and operations for communication, service, documents, and insight.</p>
  </header>

  <div class="workspace-card-grid w-100">
    <article class="workspace-app-card d-flex flex-column align-items-stretch bg-white border shadow-sm text-start">
      <div class="workspace-card-top d-flex align-items-center min-w-0">
        <div class="workspace-platform-icon tone-slate d-inline-flex align-items-center justify-content-center flex-shrink-0">
          <i class="fa-solid fa-calendar-check gradient-text" aria-hidden="true"></i>
        </div>
        <div class="workspace-card-title min-w-0 text-start">
          <h2 class="mb-1">Manage Community Events</h2>
          <p class="mb-0">Events & Attendance</p>
        </div>
      </div>

      <p class="workspace-card-description mb-0 text-start">
        Schedule events, track attendees, send reminders, and manage community updates from one place.
      </p>

      <button class="btn upload-button workspace-card-cta d-inline-flex align-items-center justify-content-center w-100" type="button" @click="launch_workspace('events')">
        Manage Events <span aria-hidden="true">&rarr;</span>
      </button>
    </article>

    <article class="workspace-app-card d-flex flex-column align-items-stretch bg-white border shadow-sm text-start">
      <div class="workspace-card-top d-flex align-items-center min-w-0">
        <div class="workspace-platform-icon tone-mint d-inline-flex align-items-center justify-content-center flex-shrink-0">
          <i class="fa-solid fa-comments gradient-text" aria-hidden="true"></i>
        </div>
        <div class="workspace-card-title min-w-0 text-start">
          <h2 class="mb-1">Community News Feed</h2>
          <p class="mb-0">Announcements & Alerts</p>
        </div>
      </div>

      <p class="workspace-card-description mb-0 text-start">
        Share announcements, alerts, updates, and multimedia posts to keep your community informed instantly.
      </p>

      <button class="btn upload-button workspace-card-cta d-inline-flex align-items-center justify-content-center w-100" type="button" @click="launch_workspace('community')">
        Open Feed <span aria-hidden="true">&rarr;</span>
      </button>
    </article>

    <article class="workspace-app-card d-flex flex-column align-items-stretch bg-white border shadow-sm text-start">
      <div class="workspace-card-top d-flex align-items-center min-w-0">
        <div class="workspace-platform-icon tone-sky d-inline-flex align-items-center justify-content-center flex-shrink-0">
          <i class="fa-solid fa-file-lines gradient-text" aria-hidden="true"></i>
        </div>
        <div class="workspace-card-title min-w-0 text-start">
          <h2 class="mb-1">Share Documents & Notices</h2>
          <p class="mb-0">Records & Communication</p>
        </div>
      </div>

      <p class="workspace-card-description mb-0 text-start">
        Upload and distribute notices, minutes, reports, and documents to your community with structured access.
      </p>

      <button class="btn upload-button workspace-card-cta d-inline-flex align-items-center justify-content-center w-100" type="button">
        Share Document <span aria-hidden="true">&rarr;</span>
      </button>
    </article>
  </div>
</div>
